(() => {
  'use strict';

  const SELECTOR = '[data-img-reveal]';
  const LOADED_CLASS = 'is-loaded';

  const prefersReducedMotion = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const getImg = (el) => {
    if (el.tagName === 'IMG') return el;
    return el.querySelector('img');
  };

  const markLoaded = (el) => {
    el.classList.add(LOADED_CLASS);
  };

  const decodeOrLoad = async (img) => {
    if (img.complete && img.naturalWidth > 0) return;

    await new Promise((resolve) => {
      const done = () => resolve();
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    });
  };

  const reveal = async (el) => {
    if (el.classList.contains(LOADED_CLASS)) return;

    const img = getImg(el);

    if (!img) {
      markLoaded(el);
      return;
    }

    if (!img.decoding) img.decoding = 'async';

    try {
      // If browser supports decode(), it can avoid showing partially decoded images
      if (typeof img.decode === 'function') {
        // decode() can reject if image isn't ready yet; fallback to load
        if (img.complete && img.naturalWidth > 0) {
          await img.decode().catch(() => {});
        } else {
          await decodeOrLoad(img);
          await img.decode().catch(() => {});
        }
      } else {
        await decodeOrLoad(img);
      }
    } catch (_) {
      // fail open
    } finally {
      // Make visible even if error
      markLoaded(el);
    }
  };

  const init = () => {
    const els = Array.from(document.querySelectorAll(SELECTOR)).filter((el) => {
      const mode = el.getAttribute('data-img-reveal');
      if (mode === 'none') return false;
      if (el.hasAttribute('data-img-reveal-skip')) return false;
      return true;
    });

    if (!els.length) return;

    if (prefersReducedMotion()) {
      els.forEach(markLoaded);
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          io.unobserve(el);
          reveal(el);
        });
      },
      {
        root: null,
        rootMargin: '200px 0px',
        threshold: 0.01,
      }
    );

    els.forEach((el) => io.observe(el));

    // TODO: do we need
    document.addEventListener('shopify:section:load', () => {
      const fresh = Array.from(document.querySelectorAll(SELECTOR)).filter(
        (el) => !el.classList.contains(LOADED_CLASS)
      );
      fresh.forEach((el) => {
        const mode = el.getAttribute('data-img-reveal');
        if (mode === 'none') return;
        if (el.hasAttribute('data-img-reveal-skip')) return;
        io.observe(el);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
